// @react/hooks/useBillingCredit.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { billingCreditStore } from '@core/stores';

/**
 * React hook for CreditGrant operations.
 * Uses MobX store directly - wrap components with observer() for reactivity.
 *
 * @example
 * ```tsx
 * import { observer } from '@react';
 * import { useBillingCredit } from '@react/hooks';
 *
 * const CreditGrantList = observer(() => {
 *   const store = useBillingCredit();
 *
 *   useEffect(() => {
 *     store.items; // access observable state
 *   }, []);
 *
 *   if (store.isLoading) return <div>Loading...</div>;
 *
 *   return (
 *     <ul>
 *       {store.items.map(item => <li key={item.id}>{item.name}</li>)}
 *     </ul>
 *   );
 * });
 * ```
 */
export function useBillingCredit() {
  return billingCreditStore;
}
